export default "__VITE_ASSET__cda9cc1a__"